import React, { ForwardedRef, useState } from 'react'
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons'
import {
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  InputProps,
  InputRightElement,
  Text,
  VStack
} from '@chakra-ui/react'
import { useField, useFormikContext } from 'formik'
import { themeColors } from 'theme'

import FormControl, { BaseProps } from '../FormControl'

export type InputControlProps = BaseProps & { inputProps?: InputProps };

export const InputControl: React.FC<InputControlProps> = React.forwardRef(
  (props: InputControlProps, ref: ForwardedRef<HTMLInputElement>) => {
    const {
      name,
      label,
      inputProps,
      inputType = 'default',
      availableElements = false,
      SelectionElement,
      handleOnChange,
      ...rest
    } = props
    const [{ onBlur: handleBur, onChange: handleChange, ...field }] = useField(name)
    const { setFieldValue } = useFormikContext()
    const [show, setShow] = useState(false)

    const { input: { bgIconColor, bgIconButtonColor, bgSelectColor, bgBorderColor } } = themeColors


    const handleClick = () => setShow(!show)

    const handleParseRut = (rut: string) => {
      const value = rut.replace(/-/g, '')

      const body = value.slice(0, -1)
      const d = value.slice(-1).toUpperCase()

      return body && d ? `${body}-${d}` : `${body}${d}`
    }

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>): void => {
      let newValue = e.target.value

      inputType === 'rut' ? (newValue = handleParseRut(e.target.value)) : newValue
      inputType === 'contact' ? (handleOnChange && handleOnChange(newValue)) : newValue
      setFieldValue(name, newValue)
    }

    return (
      <FormControl name={name} label={label} {...rest}>
        <InputGroup zIndex={'dropdown'} flexDirection={'column'}>
          <Input
            ref={ref}
            id={name}
            autoComplete='off'
            onChange={inputType !== 'default' ? handleInput : handleChange(name)}
            type={(inputType === 'password') && !show ? 'password' : 'text'}
            onBlur={handleBur(name)}
            {...field}
            {...inputProps}
            {...inputType === 'phone' && { pl: 14 }}
            {...availableElements && {
              _focus: {
                borderColor: bgBorderColor,
                borderWidth: 1, borderBottomRadius: 0, borderBottomColor: 'transparent'
              }
            }}
          />
          {inputType === 'phone' &&
            <InputLeftElement ml={3}>
              <Text fontSize={'13px'} textAlign={'right'}>(+569) </Text>
            </InputLeftElement>
          }
          {inputType === 'password' &&
            <InputRightElement mr={3}>
              <Icon
                _pressed={{ bg: bgIconButtonColor }}
                boxSize={7}
                cursor={'pointer'}
                onClick={handleClick}
                color={bgIconColor}
                as={show ? ViewIcon : ViewOffIcon}
              />
            </InputRightElement>
          }
          {availableElements && SelectionElement &&
            <VStack
              bgColor={bgSelectColor}
              borderBottomRadius={30}
              px={'1.5rem'}
              borderWidth={1}
              borderTopWidth={0}
              borderTopColor={'transparent'}
              borderColor={bgBorderColor}
            >
              {SelectionElement.length > 3 ? SelectionElement.splice(0, 3) : SelectionElement}
            </VStack>
          }
        </InputGroup>
      </FormControl>
    )
  }
)

export default InputControl
